import { useEffect, useState } from 'react';
import LoggedLayout from 'layouts/LoggedLayout';
import axios from 'axios';
import moment from 'moment';
import styled from 'styled-components';
import { assets } from 'helpers/generic';
import GlobalConfigModal from './GlobalConfigModal';

const Filters = styled.div`
	display: flex;
	justify-content: end;

	.filters-inputs {
		display: flex;
		flex-direction: row;
		align-items: center;
		flex-wrap: nowrap;

		@media (max-width: 1200px) {
			& {
				display: flex !important;
				justify-content: flex-end;
				width: 100% !important;
			}
		}

		@media (min-width: 576px) and (max-width: 1200px) {
			& > *:nth-child(2) {
				min-width: 200px;
			}
		}

		@media (min-width: 768px) and (max-width: 991px) {
			#search-box {
				flex: 1;
			}
		}

		@media (max-width: 576px) {
			flex-direction: column;
			align-items: stretch;
			gap: 1rem;
			width: 100%;
			max-width: 100%;
			box-sizing: border-box;

			& > * {
				width: 100%;
				max-width: 100%;
				min-width: 0;
				box-sizing: border-box;
			}

			#search-box {
				width: 100%;
				max-width: 100%;
				min-width: 0;
				box-sizing: border-box;
			}
		}

		@media (max-width: 374px) {
			& {
				margin: auto;
			}
		}
	}

	.filter-buttons{
		width: auto !important;

		& > * {
			@media (max-width: 576px) {
				width: 100%;
				text-align: center;
			}
		}

		@media (max-width: 1200px) {
			margin-right: 0.5rem;
		}

		@media (max-width: 991px) {
			width: calc(100% - 1.5rem) !important;
		}

		@media (max-width: 767px) {
			width: calc(100% - 2rem);
		}

		@media (max-width: 576px) {
			display: flex !important;
			flex-direction: column !important;
			flex-wrap: nowrap;
			align-items: stretch !important;
			width: 100% !important;
		}
	}
	
	@media (max-width: 1200px) {
		justify-content: center;
		flex-direction: column;
		align-items: flex-end;

		& > *,
		.empowered-selector {
			width: 100% !important;
			display: block !important;
		}

		& > * {
			margin-bottom: 10px;
		}
	}

	@media (max-width: 991px) {
		display: grid;
		grid-template-columns: 1fr;
		grid-auto-rows: auto;
		gap: 10px;
		align-items: stretch;

		& > * {
			width: 100% !important;
			margin-bottom: 0 !important;
		}
	}

	@media (max-width: 767px) {
		grid-template-columns: 1fr;
	}
`;

let axiosCancelToken = null;

export default function ProbesWarnings() {
	let [stations, setStations] = useState([]);
	let [forcedProbesLoading, setForcedProbesLoading] = useState({});
	const [globalConfigModalOpened, setGlobalConfigModalOpened] = useState(null);

	useEffect(() => {
		axiosCancelToken = axios.CancelToken.source();

		return function cleanup() {
           	axiosCancelToken.cancel();
        }
	}, []);

	useEffect(() => {
		const getStations = async () => {
			return axios.get('api/probes-warnings/list', {
				params: {},
				cancelToken: axiosCancelToken.token
			}).then((response) => {
		    	setStations(response.data);
		  	}).catch((error) => {
				if ( axios.isCancel(error) ) return;
			});
		}
		getStations();

		let interval = setInterval(() => {
			getStations();
		}, 10000);

		return function cleanup() {
			clearInterval(interval);
		}
	}, []);

	const forceProbe = (station) => {
		setForcedProbesLoading((prev) => ({...prev, [station.id]: true}));

		axios.get('api/probes/get/' + station.octan_id, {
			params: {},
			cancelToken: axiosCancelToken.token
		}).then((response) => {
			
		}).catch((error) => {
			if ( axios.isCancel(error) ) return;
		}).then(() => {
			setForcedProbesLoading((prev) => {
				delete prev[station.id];
				return prev;
			});
		});
	}

	return (
		<LoggedLayout>
			<div className="col-md-12 mb-3">
				<div className="bg-white p-2 rounded shadow-sm">
					<div className="row">
						<div className="col-lg-10 align-content-center">
							<h4 className="mb-0">Avisos de sondas</h4>
						</div>
						<Filters className="col-lg-2">
							<div className="d-flex flex-row flex-nowrap align-items-center gap-1 filter-buttons" style={{whiteSpace: 'nowrap', width: 'calc(100% - 2rem)'}}>
								<button className="btn btn-sm btn-plenoil-light btn-plenoil p-0 px-2 d-inline-flex align-items-center text-nowrap col-4 col-lg-auto gap-2" onClick={() => setGlobalConfigModalOpened(true)}><i className="bi bi-pencil"></i> Configuración</button>
							</div>
						</Filters>
					</div>
				</div>
			</div>

			<div className="pt-2 col-md-12">
				<div className="px-0 col-lg pl-lg-0">
					<div className="row m-0 pb-2">
						<div className="col-12 px-0">
							<div className="h-100 p-4 background-color-blanco shadow rounded">
								<div className="table-responsive-rows">
									<div className="mvc-grid mvc-grid-header-mode">
										<div className="mvc-grid-table">
											<table>
												<thead>
													<tr className="bg-plenoil-primary text-plenoil-black">
														<th className="title_precios-estacion">Estación</th>
														<th className="title_precios-goa">GOA</th>
														<th className="title_precios-sp95">SP95</th>
													</tr>
												</thead>
												<tbody>
													{ stations.map((el, idx) => {
														return (
															<tr key={idx}>
																<td className="title_precios-estacion">
																	{el.name}

																	<button 
																		className="btn btn-plenoil btn-plenoil-outline-blue p-0 float-end" 
																		onClick={() => forcedProbesLoading.hasOwnProperty(el.id) ? null : forceProbe(el)}
																	>
																		{forcedProbesLoading.hasOwnProperty(el.id) ? 'forzando sonda...' : 'forzar sonda'}
																	</button>
																</td>
																<td className={`title_precios-goa ${el.probewarning?.goa_warning_at || el.probewarning?.goa_h2o_warning_at ? 'warning' : ''}`}> 
																	{el.probewarning?.goa_lastcheck_at ?
																		<div className="date">
																			{moment(el.probewarning.goa_lastcheck_at).format('DD-MM-YYYY HH:mm')}
																		</div>
																		:
																		<small className="no-info">no hay información disponible</small>
																	}
																	{el.probewarning?.goa_liters &&
																		<div className="liters">
																			{el.probewarning?.goa_liters}&nbsp;litros
																		</div>
																	}
																	{el.probewarning?.goa_percent  &&
																		<div className="progress">
																			<div className="progress-bar" style={{background: 'var(--plenoil-blue)', width: (el.probewarning?.goa_percent ?? 0) + '%'}}>{el.probewarning?.goa_percent ?? '-'} %</div>
																		</div>
																	}
																	{el.probewarning?.goa_h2o_warning_at &&
																		<div className="h2o_warning parpadeo mt-2" style={{ color: 'var(--plenoil-red)', display: 'flex', alignItems: 'flex-end' }}>
																			<img src={assets('/img/iconoagua.svg')} alt="warning" className="h2o_warning" style={{ width: '30px', height: '30px', objectFit: 'contain' }} />
																			tiene agua
																		</div>
																	}
																</td>
																<td className={`title_precios-sp95 ${el.probewarning?.sp95_warning_at || el.probewarning?.sp95_h2o_warning_at ? 'warning' : ''}`}>
																	{el.probewarning?.sp95_lastcheck_at ?
																		<div className="date">
																			{moment(el.probewarning.sp95_lastcheck_at).format('DD-MM-YYYY HH:mm')}
																		</div>
																		:
																		<small className="no-info">no hay información disponible</small>
																	}
																	{el.probewarning?.sp95_liters &&
																		<div className="liters">
																			{el.probewarning?.sp95_liters}&nbsp;litros
																		</div>
																	}
																	{el.probewarning?.sp95_percent  &&
																		<div className="progress">
																			<div className="progress-bar" style={{background: 'var(--plenoil-blue)', width: el.probewarning?.sp95_percent + '%'}}>{el.probewarning?.sp95_percent ?? '-'} %</div>
																		</div>
																	}
																	{el.probewarning?.sp95_h2o_warning_at &&
																		<div className="h2o_warning parpadeo mt-2" style={{ color: 'var(--plenoil-red)', display: 'flex', alignItems: 'flex-end' }}>
																			<img src={assets('/img/iconoagua.svg')} alt="warning" className="h2o_warning" style={{ width: '30px', height: '30px', objectFit: 'contain' }} />
																			tiene agua
																		</div>
																	}
																</td>
															</tr>
														)
													}) }
													{ !stations.length && <tr key="empty"><td colSpan="100%">No hay estaciones</td></tr> }
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{globalConfigModalOpened &&
				<GlobalConfigModal 
					closeCallback={() => {
						setGlobalConfigModalOpened(null);
					}}
				/>
			}
		</LoggedLayout>
	);
}


